import { Theme } from '@emotion/react';

export const generateBackToLinkStyles = (theme: Theme) => ({
    wrapper: {
        marginTop: '16px',
        marginBottom: '24px',
        fontSize: '14px',
        fontFamily: theme.palette.common.font,
    },
});
